<div id="wrapper" [style.background-image]="'url(' + imageSrc + ')'">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="logo-family" id="title">{{
        appName
      }}</mat-card-title>
      <mat-card-subtitle id="subtitle">JOURNEY TELLING</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <form
        [formGroup]="signInForm"
        (ngSubmit)="signInForm.valid && onSubmit()"
        *ngIf="!requiresOtp; else otpForm"
      >
        <mat-form-field>
          <input
            type="email"
            matInput
            formControlName="email"
            placeholder="Enter your email or phone number"
          />
          @if (signInForm.get("email")?.hasError("emailOrPhone")) {
            <mat-error
              >Please enter a valid email address or phone number</mat-error
            >
          }
          @if (signInForm.get("email")?.hasError("required")) {
            <mat-error>Email or phone number is required</mat-error>
          }
          @if (signInForm.valid) {
            <button matSuffix mat-icon-button aria-label="Login" type="submit">
              <mat-icon>login</mat-icon>
            </button>
          }
        </mat-form-field>
      </form>
      <ng-template #otpForm>
        <form
          [formGroup]="otpFormGroup"
          (ngSubmit)="otpFormGroup.valid && onSubmitOtp()"
        >
          <mat-form-field>
            <input
              matInput
              formControlName="otp"
              placeholder="Please enter the token that you received via SMS"
              maxlength="6"
            />
            @if (otpFormGroup.get("otp")?.hasError("minlength")) {
              <mat-error>Please enter a valid token</mat-error>
            }
            @if (otpFormGroup.get("otp")?.hasError("required")) {
              <mat-error>Token is required</mat-error>
            }
            @if (otpFormGroup.valid) {
              <button
                matSuffix
                mat-icon-button
                aria-label="Login"
                type="submit"
              >
                <mat-icon>login</mat-icon>
              </button>
            }
          </mat-form-field>
        </form>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>
